import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getEnumKeyFromValue' })
export class GetEnumKeyFromValuePipe implements PipeTransform {
    transform(value: number, enumeration) {
        return enumeration[value];
    }
}
